import { render, staticRenderFns } from "./FeedbackSendCard.vue?vue&type=template&id=6e37379c"
import script from "./FeedbackSendCard.vue?vue&type=script&lang=js"
export * from "./FeedbackSendCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports